"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  GoToProduct: true,
  Products: true,
  defaultTranslations: true,
  translationsNamespace: true
};
Object.defineProperty(exports, "GoToProduct", {
  enumerable: true,
  get: function () {
    return _components.GoToProduct;
  }
});
Object.defineProperty(exports, "Products", {
  enumerable: true,
  get: function () {
    return _components.Products;
  }
});
Object.defineProperty(exports, "defaultTranslations", {
  enumerable: true,
  get: function () {
    return _defaultTranslations.defaultTranslations;
  }
});
Object.defineProperty(exports, "translationsNamespace", {
  enumerable: true,
  get: function () {
    return _defaultTranslations.translationsNamespace;
  }
});
var _ShadePickerController = require("./containers/ShadePickerController");
Object.keys(_ShadePickerController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ShadePickerController[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ShadePickerController[key];
    }
  });
});
var _components = require("./components");
var _defaultTranslations = require("./constants/defaultTranslations");
//# sourceMappingURL=index.js.map